<template>
  <div class="hero">
    <picture>
      <source
        srcset="~@/assets/images/magazines/header.png"
        media="(min-width: 900px)"
      />
      <img
        src="~@/assets/images/magazines/master.png"
        alt="1日1問国試マスター"
      />
    </picture>
  </div>
</template>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var.$color-main;
}
img {
  max-height: 240px;
}
</style>
